import ShowInformation from "./ShowInformation";
import Create from "./Create";
import Update from "./Update";
import Search from "./Search";
import Filter from "./Filter";
import Body from "./Body";

const Components = {
  ShowInformation,
  Create,
  Update,
  Search,
  Filter,
  Body,
};

export default Components;
